/**
 * Roboparts Quiz – Kompatibilitäts-Finder
 *
 * Ablauf: Marke (Backend) → Modell (aus Produkt-Tags) → [Baujahr] → [Tellergröße/Durchmesser] → Ergebnisse
 * - Marken: Section-Blöcke (product_tag → brand_xyz)
 * - Modelle: modell_* Tags aus Produkten der gewählten Marke
 * - Baujahr/Tellergröße: optional, wenn Produkte baujahr_/size_ Tags haben
 * - Worx: Baujahr-Schritt nur für Tags modell_s und modell_m; alle anderen Worx-Modelle ohne Baujahr
 * - Produkte ohne baujahr_/size_ (z.B. Bundles) werden immer angezeigt
 */
(function() {
  'use strict';

  const STRINGS = (function() {
    try {
      const el = document.getElementById('rq-strings-data');
      return el ? { btnAddToCart: 'In den Warenkorb', btnAdding: 'Wird hinzugefügt…', btnInCart: 'Im Warenkorb', linkToProduct: 'Zum Produkt', progressStep: 'Schritt', progressOf: 'von', otherSuccess: 'Danke! Wir melden uns bei dir.', btnOtherBrand: 'Andere Marke', btnOtherModel: 'Anderes Modell', ...JSON.parse(el.textContent || '{}') } : {};
    } catch (_) {
      return { btnAddToCart: 'In den Warenkorb', btnAdding: 'Wird hinzugefügt…', btnInCart: 'Im Warenkorb', linkToProduct: 'Zum Produkt', progressStep: 'Schritt', progressOf: 'von', otherSuccess: 'Danke! Wir melden uns bei dir.', btnOtherBrand: 'Andere Marke', btnOtherModel: 'Anderes Modell' };
    }
  })();

  const configEl = document.getElementById('rq-config-data');
  const CONFIG = Object.assign({
    storefrontAccessToken: 'SET_YOUR_STOREFRONT_ACCESS_TOKEN',
    shopDomain: '',
    apiVersion: '2024-01',
    supportEmail: 'customersupport@beos-tools.com',
    modelBlacklist: {
      'Gardena': ['aspire'],
      'Husqvarna': ['minimo'],
      'eufy': ['s-serie', 'v-serie'],
      'terramow': ['e15', 'e18']
    },
    /** Baujahr-Tags pro Modell, die nicht angezeigt werden (z.B. modell_luba_3: ['ab_2025']) */
    baujahrBlacklist: { 'modell_luba_3': ['ab_2025'] },
    /** Messer-Produkte mit diesen modell_-Tags ausblenden, wenn selectedModel passt. z.B. modell_mova: ['modell_a'] */
    messerModelExclusions: { 'modell_mova': ['modell_a'] },
    /**
     * Nur Produkte mit diesen Tags anzeigen, wenn eines der Modelle gewählt ist.
     * Vergleich erfolgt case-insensitiv.
     */
    modelResultTagAllowlist: {
      'modell_mova_vivax': ['teller', 'messer', 'modell_mova_lidax_ultra', 'modell_mova_vivax'],
      'modell_mova_lidax_ultra': ['teller', 'messer', 'modell_mova_lidax_ultra', 'modell_mova_vivax']
    }
  }, configEl ? JSON.parse(configEl.textContent || '{}') : {});

  const API_URL = `https://${CONFIG.shopDomain}/api/${CONFIG.apiVersion}/graphql.json`;

  const state = {
    products: [],
    selectedBrand: null,
    selectedBrandLabel: null,
    selectedModel: null,
    selectedBaujahr: null,
    selectedTyp: null,
    hasBaujahrStep: false,
    hasTypStep: false,
    currentStep: 1
  };

  const el = {
    root: null,
    loading: null,
    error: null,
    quiz: null,
    progressFill: null,
    progressLabel: null,
    stepBrand: null,
    stepModel: null,
    stepOtherBrand: null,
    stepOtherModel: null,
    stepBaujahr: null,
    stepTyp: null,
    stepResults: null,
    optionsBrand: null,
    optionsModel: null,
    optionsBaujahr: null,
    optionsTyp: null,
    resultsGrid: null,
    noResults: null,
    newsletterForm: null,
    newsletterSuccess: null
  };

  function $(id) {
    return document.getElementById(id);
  }

  /**
   * GTM dataLayer Tracking
   */
  const FunnelConfig = {
    eventName: 'roboparts_quiz'
  };

  function dlPush(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function getVisibleStepName() {
    if (isStepVisible(el.stepResults)) return 'results';
    if (isStepVisible(el.stepTyp)) return 'typ';
    if (isStepVisible(el.stepBaujahr)) return 'baujahr';
    if (isStepVisible(el.stepOtherBrand)) return 'other_brand';
    if (isStepVisible(el.stepOtherModel)) return 'other_model';
    if (isStepVisible(el.stepModel)) return 'model';
    return 'brand';
  }

  function baseQuizParams() {
    return {
      quiz_step: getVisibleStepName(),
      quiz_step_index: typeof state.currentStep === 'number' ? state.currentStep : null,
      brand_tag: state.selectedBrand || null,
      brand_label: state.selectedBrandLabel || null,
      model_tag: state.selectedModel || null,
      baujahr_tag: state.selectedBaujahr || null,
      typ_tag: state.selectedTyp || null
    };
  }

  function trackQuiz(quiz_action, extra) {
    dlPush(Object.assign({ event: FunnelConfig.eventName, quiz_action }, baseQuizParams(), extra || {}));
  }

  function trackFunnel(step, data) {
    const d = data || {};
    if (step === 'brand_view') {
      trackQuiz('step_view', { quiz_step: 'brand', quiz_step_index: 1 });
      return;
    }
    if (step === 'model_view') {
      trackQuiz('step_view', { quiz_step: 'model' });
      return;
    }
    if (step === 'baujahr_view') {
      trackQuiz('step_view', { quiz_step: 'baujahr' });
      return;
    }
    if (step === 'typ_view') {
      trackQuiz('step_view', { quiz_step: 'typ' });
      return;
    }
    if (step === 'results_view') {
      trackQuiz('results_view', {
        quiz_step: 'results',
        has_results: !!d.hasResults,
        results_count: typeof d.resultsCount === 'number' ? d.resultsCount : null
      });
      return;
    }
    if (step === 'brand_selected') {
      trackQuiz('select_brand', {
        brand_tag: d.brand_tag || state.selectedBrand || null,
        brand_label: d.brand_label || d.brand || state.selectedBrandLabel || null
      });
      return;
    }
    if (step === 'model_selected') {
      trackQuiz('select_model', { model_tag: d.model_tag || d.model || state.selectedModel || null });
      return;
    }
    if (step === 'baujahr_selected') {
      trackQuiz('select_baujahr', { baujahr_tag: d.baujahr_tag || d.baujahr || state.selectedBaujahr || null });
      return;
    }
    if (step === 'typ_selected') {
      trackQuiz('select_typ', { typ_tag: d.typ_tag || d.typ || state.selectedTyp || null });
      return;
    }
    if (step === 'newsletter_submitted') {
      trackQuiz('newsletter_submit');
      return;
    }
    if (step === 'quiz_error') {
      trackQuiz('quiz_error', { reason: d.reason || null });
      return;
    }
    if (typeof step === 'string' && step.startsWith('back_from_')) return;
  }

  function gidToVariantId(gid) {
    if (typeof gid !== 'string') return gid;
    const parts = gid.split('/');
    return parts[parts.length - 1] || gid;
  }

  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function formatPrice(amount, currencyCode) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currencyCode || 'EUR'
    }).format(parseFloat(amount));
  }

  function brandLabelToTag(brand) {
    if (!brand) return '';
    return 'brand_' + brand.toLowerCase().replace(/\s+/g, '_');
  }

  function isWorxBrandSelected() {
    const tag = String(state.selectedBrand || '').trim().toLowerCase();
    if (tag === 'brand_worx') return true;
    const label = String(state.selectedBrandLabel || '').trim().toLowerCase();
    return label === 'worx';
  }

  /** Worx: Baujahr nur für Modell-Tags modell_s und modell_m (case-insensitive). */
  function isWorxBaujahrEligibleModel(modelTag) {
    if (!modelTag) return false;
    const ml = String(modelTag).trim().toLowerCase();
    return ml === 'modell_s' || ml === 'modell_m';
  }

  function isSegwayNavimowBrandSelected() {
    const tag = String(state.selectedBrand || '').trim().toLowerCase();
    if (tag === 'brand_segway_navimow') return true;
    const label = String(state.selectedBrandLabel || '').trim().toLowerCase();
    return label === 'segway navimow' || label === 'segway_navimow';
  }

  function productHasBrand(product, brand) {
    if (!product.tags || !Array.isArray(product.tags) || !brand) return false;
    const tag = (typeof brand === 'string' && brand.startsWith('brand_')) ? brand : brandLabelToTag(brand);
    const tagNorm = String(tag).trim().toLowerCase();
    return product.tags.some(t => t && String(t).trim().toLowerCase() === tagNorm);
  }

  function getProductsByBrand(brand) {
    return state.products.filter(p => productHasBrand(p, brand));
  }

  /** Ersatzmesser-Produkte für eine Marke (passen für alle Modelle). Filter: brand_ + Tag "messer". */
  function getMesserProductsForBrand(brand) {
    return state.products.filter(p => {
      if (!productHasBrand(p, brand)) return false;
      return (p.tags || []).some(t => String(t).trim().toLowerCase() === 'messer');
    });
  }

  function tagMatches(tag, expected) {
    return tag && expected && String(tag).trim().toLowerCase() === String(expected).trim().toLowerCase();
  }

  function getTagsFromProducts(products, prefix, transform) {
    const seen = new Set();
    const out = [];
    const prefixLower = prefix.toLowerCase();
    for (const p of products || []) {
      if (!p.tags) continue;
      for (const t of p.tags) {
        if (t && String(t).toLowerCase().startsWith(prefixLower)) {
          const val = transform ? transform(t) : t;
          const key = (val && String(val).toLowerCase()) || '';
          if (key && !seen.has(key)) { seen.add(key); out.push(val); }
        }
      }
    }
    return out.sort((a, b) => String(a).localeCompare(String(b), 'de'));
  }
  const getModelTagsFromProducts = p => getTagsFromProducts(p, 'modell_');
  const getBaujahrTagsFromProducts = p => getTagsFromProducts(p, 'baujahr_');
  const getTypTagsFromProducts = p => getTagsFromProducts(p, 'size_');

  function tagToLabel(tag, prefix, sep) {
    if (!tag || !tag.startsWith(prefix)) return tag;
    const raw = tag.replace(new RegExp('^' + prefix), '').replace(/_/g, sep || ' ');
    return raw.split(' ').map(w => w.charAt(0).toUpperCase() + (w.slice(1) || '').toLowerCase()).join(' ');
  }
  const baujahrToLabel = t => tagToLabel(t, 'baujahr_');
  const modellToLabel = t => tagToLabel((t || '').replace(/-/g, '_'), 'modell_', ' ');
  const typToLabel = t => {
    const raw = String(t || '').trim();
    if (!raw.toLowerCase().startsWith('size_')) return raw;
    const val = raw.slice('size_'.length);
    // Expected tags: size_14.6cm, size_15cm, size_17cm → show: 14.6 cm, 15 cm, 17 cm
    return val
      .replace(/_/g, ' ')
      .replace(/cm\b/i, ' cm')
      .replace(/\s+/g, ' ')
      .trim();
  };

  function filterBlacklistedModels(tags, brand) {
    const blacklist = CONFIG.modelBlacklist;
    if (!blacklist || !brand) return tags;
    const bl = String(brand).toLowerCase();
    let blocked = blacklist[brand] || blacklist[bl];
    if (!blocked) {
      const key = Object.keys(blacklist).find(k => String(k).toLowerCase() === bl);
      blocked = key ? blacklist[key] : undefined;
    }
    if (!Array.isArray(blocked) || blocked.length === 0) return tags;
    const blockedLower = blocked.map(s => String(s).toLowerCase());
    return tags.filter(tag => {
      const raw = String(tag).replace(/^modell_/i, '');
      return !blockedLower.includes(raw.toLowerCase());
    });
  }

  function filterBlacklistedBaujahr(tags, modelTag) {
    const blacklist = CONFIG.baujahrBlacklist;
    if (!blacklist || !modelTag) return tags;
    const ml = String(modelTag).toLowerCase();
    let blocked = blacklist[modelTag] || blacklist[ml];
    if (!blocked) {
      const key = Object.keys(blacklist).find(k => String(k).toLowerCase() === ml);
      blocked = key ? blacklist[key] : undefined;
    }
    if (!Array.isArray(blocked) || blocked.length === 0) return tags;
    const blockedLower = blocked.map(s => String(s).toLowerCase());
    return tags.filter(tag => {
      const raw = String(tag).replace(/^baujahr_/i, '');
      return !blockedLower.includes(raw.toLowerCase());
    });
  }

  async function fetchAllProducts() {
    const all = [];
    let cursor = null;

    const query = `
      query GetProducts($cursor: String) {
        products(first: 250, after: $cursor) {
          pageInfo { hasNextPage endCursor }
          edges {
            node {
              id
              title
              handle
              tags
              availableForSale
              featuredImage { url altText }
              priceRange {
                minVariantPrice { amount currencyCode }
              }
              variants(first: 10) {
                edges {
                  node {
                    id
                    availableForSale
                  }
                }
              }
            }
          }
        }
      }
    `;

    const runFetchLoop = async () => {
      cursor = null;
      do {
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': CONFIG.storefrontAccessToken
          },
          body: JSON.stringify({
            query,
            variables: { cursor: cursor || null }
          })
        });

        const json = await res.json();

        if (json.errors) {
          const msg = json.errors[0]?.message || 'GraphQL Fehler';
          throw new Error(msg);
        }
        if (!json.data || !json.data.products) {
          throw new Error(res.status === 401 || res.status === 403
            ? 'Storefront Token ungültig oder abgelaufen. Bitte prüfen.'
            : 'Ungültige API-Antwort');
        }

        const { products } = json.data;
        for (const edge of products.edges) {
          const node = edge.node;
          const variantEdges = node.variants?.edges || [];
          const firstAvailable = variantEdges.find(e => e?.node?.availableForSale)?.node;
          const firstVariant = variantEdges[0]?.node;

          let tags = node.tags;
          if (typeof tags === 'string') tags = tags.split(',').map(t => t.trim()).filter(Boolean);
          if (!Array.isArray(tags)) tags = [];
          tags = tags.map(t => t && String(t).trim()).filter(Boolean);

          all.push({
            id: node.id,
            title: node.title,
            handle: node.handle,
            tags,
            featuredImage: node.featuredImage,
            priceRange: node.priceRange,
            variantId: (firstAvailable || firstVariant)?.id,
            availableForSale: node.availableForSale ?? false
          });
        }

        cursor = products.pageInfo.hasNextPage ? products.pageInfo.endCursor : null;
      } while (cursor);
    };

    await runFetchLoop();

    return all;
  }

  function showState(name) {
    ['loading', 'error', 'quiz'].forEach(s => {
      const node = el[s];
      if (node) node.classList.toggle('rq-hidden', s !== name);
    });
    const root = el.root;
    if (root) root.setAttribute('aria-busy', name === 'loading');
  }

  function getTotalSteps() {
    return 3 + (state.hasBaujahrStep ? 1 : 0) + (state.hasTypStep ? 1 : 0);
  }

  function getFilteredModelProducts() {
    const bp = getProductsByBrand(state.selectedBrand);
    return state.selectedModel ? bp.filter(p => p.tags?.some(t => tagMatches(t, state.selectedModel))) : bp;
  }

  function getFilteredBaujahrProducts() {
    const mp = getFilteredModelProducts();
    return state.selectedBaujahr ? mp.filter(p => p.tags?.some(t => tagMatches(t, state.selectedBaujahr))) : mp;
  }

  function updateProgress(step, totalSteps) {
    const pct = totalSteps > 0 ? Math.round((step / totalSteps) * 100) : 0;
    if (el.progressFill) el.progressFill.style.width = pct + '%';
    if (el.progressBar) el.progressBar.setAttribute('aria-valuenow', pct);
    if (el.progressLabel) el.progressLabel.textContent = `${STRINGS.progressStep || 'Schritt'} ${step} ${STRINGS.progressOf || 'von'} ${totalSteps}`;
  }

  function hideAllSteps() {
    resetOtherForms();
    [el.stepBrand, el.stepOtherBrand, el.stepModel, el.stepOtherModel, el.stepBaujahr, el.stepTyp, el.stepResults].forEach(s => {
      if (s) s.classList.add('rq-hidden');
    });
  }

  function showStep(stepEl) {
    if (stepEl) stepEl.classList.remove('rq-hidden');
  }

  function renderOptionStep(container, items, dataAttr, toLabel, onSelect, other, getValue) {
    if (!container) return;
    const fragment = document.createDocumentFragment();
    items.forEach(item => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rq-option-btn';
      btn.dataset[dataAttr] = getValue ? getValue(item) : item;
      btn.dataset.selected = 'false';
      btn.textContent = toLabel ? toLabel(item) : item;
      btn.addEventListener('click', () => onSelect(item));
      fragment.appendChild(btn);
    });
    if (other && items.length > 0) {
      const o = document.createElement('button');
      o.type = 'button';
      o.className = 'rq-option-btn';
      o.dataset.other = other.dataAttr;
      o.textContent = other.text;
      fragment.appendChild(o);
    }
    container.innerHTML = '';
    container.appendChild(fragment);
  }

  function renderBrandStep() {
    const pills = document.querySelectorAll('#rq-options-brand-wrap .brand-filter__pill');
    pills.forEach(p => p.classList.remove('is-active'));
  }

  function selectBrand(brand) {
    const tag = brand && typeof brand === 'object' ? brand.tag : brand;
    const label = brand && typeof brand === 'object' ? brand.label : brand;
    trackFunnel('brand_selected', { brand_tag: tag, brand_label: label || tag });
    state.selectedBrand = tag;
    state.selectedBrandLabel = label || tag;
    state.selectedModel = null;
    state.selectedBaujahr = null;
    state.selectedTyp = null;

    document.querySelectorAll('#rq-options-brand-wrap .brand-filter__pill').forEach(p => {
      p.classList.toggle('is-active', p.dataset.brand === tag);
    });

    const brandProducts = getProductsByBrand(tag);
    const modelTags = filterBlacklistedModels(getModelTagsFromProducts(brandProducts), state.selectedBrandLabel);
    const baujahrTags = getBaujahrTagsFromProducts(brandProducts);
    state.hasBaujahrStep = !isWorxBrandSelected() && baujahrTags.length > 0;

    if (modelTags.length === 0 && state.hasBaujahrStep) {
      state.selectedModel = null;
      trackFunnel('baujahr_view');
      renderBaujahrStep(baujahrTags);
      hideAllSteps();
      showStep(el.stepBaujahr);
      const total = 3; // Brand, Baujahr, Results
      updateProgress(2, total);
      state.currentStep = 2;
      return;
    }

    trackFunnel('model_view');
    renderModelStep(modelTags);
    hideAllSteps();
    showStep(el.stepModel);
    updateProgress(2, getTotalSteps());
    state.currentStep = 2;
  }

  function renderModelStep(tags) {
    const isSegway = isSegwayNavimowBrandSelected();
    // For Segway Navimow we want: normal models → hardcoded series → "Anderes Modell" (last).
    renderOptionStep(
      el.optionsModel,
      tags,
      'model',
      modellToLabel,
      selectModel,
      isSegway ? null : { dataAttr: 'model', text: STRINGS.btnOtherModel || 'Anderes Modell' }
    );

    if (isSegway && el.optionsModel) {
      // Segway Navimow: hardcoded “Serien” that should route to the "Anderes Modell" screen.
      const hardcodedSeries = ['X3-Serie', 'X4-Serie', 'i2-Serie', 'H2-Serie'];
      const frag = document.createDocumentFragment();
      for (const seriesLabel of hardcodedSeries) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rq-option-btn';
        btn.dataset.customModel = seriesLabel;
        btn.textContent = seriesLabel;
        btn.addEventListener('click', () => {
          trackQuiz('click_button', {
            button_type: 'custom_model',
            button_text: seriesLabel,
            button_id: 'rq-custom-model-' + seriesLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-')
          });
          showOtherForm('model', seriesLabel);
        });
        frag.appendChild(btn);
      }

      const otherBtn = document.createElement('button');
      otherBtn.type = 'button';
      otherBtn.className = 'rq-option-btn';
      otherBtn.dataset.other = 'model';
      otherBtn.textContent = STRINGS.btnOtherModel || 'Anderes Modell';

      el.optionsModel.appendChild(frag);
      el.optionsModel.appendChild(otherBtn);
    }
  }

  function selectModel(modelTag) {
    trackFunnel('model_selected', { model_tag: modelTag });
    state.selectedModel = modelTag;
    state.selectedBaujahr = null;
    state.selectedTyp = null;

    document.querySelectorAll('.rq-option-btn[data-model]').forEach(b => {
      b.dataset.selected = (b.dataset.model === modelTag).toString();
    });

    const modelProducts = getProductsByBrand(state.selectedBrand).filter(p =>
      p.tags && p.tags.some(t => tagMatches(t, modelTag))
    );
    let baujahrTags = getBaujahrTagsFromProducts(modelProducts);
    baujahrTags = filterBlacklistedBaujahr(baujahrTags, modelTag);
    const worxAllowsBaujahr = isWorxBrandSelected() && isWorxBaujahrEligibleModel(modelTag);
    state.hasBaujahrStep = baujahrTags.length > 0 && (!isWorxBrandSelected() || worxAllowsBaujahr);

    if (state.hasBaujahrStep) {
      trackFunnel('baujahr_view');
      renderBaujahrStep(baujahrTags);
      hideAllSteps();
      showStep(el.stepBaujahr);
      updateProgress(3, getTotalSteps());
      state.currentStep = 3;
    } else {
      const typTags = getTypTagsFromProducts(modelProducts);
      state.hasTypStep = typTags.length > 0;
      if (state.hasTypStep) {
        trackFunnel('typ_view');
        renderTypStep(typTags);
        hideAllSteps();
        showStep(el.stepTyp);
        updateProgress(3, 4);
        state.currentStep = 3;
      } else {
        showResults();
      }
    }
  }

  function renderBaujahrStep(tags) {
    renderOptionStep(el.optionsBaujahr, tags, 'baujahr', baujahrToLabel, selectBaujahr);
  }

  function selectBaujahr(baujahrTag) {
    trackFunnel('baujahr_selected', { baujahr_tag: baujahrTag });
    state.selectedBaujahr = baujahrTag;
    state.selectedTyp = null;
    document.querySelectorAll('.rq-option-btn[data-baujahr]').forEach(b => {
      b.dataset.selected = (b.dataset.baujahr === baujahrTag).toString();
    });

    const baujahrProducts = getFilteredModelProducts().filter(p =>
      p.tags && p.tags.some(t => tagMatches(t, baujahrTag))
    );
    const typTags = getTypTagsFromProducts(baujahrProducts);
    state.hasTypStep = typTags.length > 0;

    if (state.hasTypStep) {
      trackFunnel('typ_view');
      renderTypStep(typTags);
      hideAllSteps();
      showStep(el.stepTyp);
      updateProgress(4, 5);
      state.currentStep = 4;
    } else {
      showResults();
    }
  }

  function renderTypStep(tags) {
    renderOptionStep(el.optionsTyp, tags, 'typ', typToLabel, selectTyp);
  }

  function selectTyp(typTag) {
    trackFunnel('typ_selected', { typ_tag: typTag });
    state.selectedTyp = typTag;
    document.querySelectorAll('.rq-option-btn[data-typ]').forEach(b => {
      b.dataset.selected = (b.dataset.typ === typTag).toString();
    });
    showResults();
  }

  function productMatchesFilter(p) {
    if (!productHasBrand(p, state.selectedBrand)) return false;
    const modelResultTagAllowlist = CONFIG.modelResultTagAllowlist;
    if (modelResultTagAllowlist && state.selectedModel) {
      const sel = String(state.selectedModel).toLowerCase();
      let allowedTags = modelResultTagAllowlist[state.selectedModel] || modelResultTagAllowlist[sel];
      if (!allowedTags) {
        const key = Object.keys(modelResultTagAllowlist).find(k => String(k).toLowerCase() === sel);
        allowedTags = key ? modelResultTagAllowlist[key] : undefined;
      }
      if (Array.isArray(allowedTags) && allowedTags.length > 0) {
        const allowedLower = allowedTags.map(t => String(t).toLowerCase());
        const productTagsLower = (p.tags || []).map(t => String(t).toLowerCase());
        const hasAllowedTag = productTagsLower.some(t => allowedLower.includes(t));
        if (!hasAllowedTag) return false;
      }
    }
    /* Ersatzmesser (Tag "messer") passen für alle Modelle der Marke – immer anzeigen, außer Blacklist */
    const hasMesserTag = (p.tags || []).some(t => String(t).trim().toLowerCase() === 'messer');
    if (hasMesserTag) {
      const exclusions = CONFIG.messerModelExclusions;
      if (exclusions && state.selectedModel) {
        const sel = String(state.selectedModel).toLowerCase();
        for (const [whenModel, excludeTags] of Object.entries(exclusions)) {
          const when = String(whenModel).toLowerCase();
          if (sel === when || sel.startsWith(when + '_')) {
            const hasExcludedTag = (Array.isArray(excludeTags) ? excludeTags : [excludeTags]).some(et =>
              (p.tags || []).some(t => tagMatches(t, et))
            );
            if (hasExcludedTag) return false;
          }
        }
      }
      return true;
    }
    if (state.selectedModel) {
      if (!p.tags) return false;
      const sel = state.selectedModel;
      const exact = p.tags.some(t => tagMatches(t, sel));
      const parent = p.tags.some(t => {
        const tl = String(t || '').toLowerCase();
        const sl = String(sel || '').toLowerCase();
        return tl.startsWith('modell_') && tl !== sl && sl.startsWith(tl);
      });
      if (!exact && !parent) return false;
    }
    if (state.hasBaujahrStep && state.selectedBaujahr) {
      const hasBaujahr = p.tags?.some(t => t && String(t).toLowerCase().startsWith('baujahr_'));
      if (hasBaujahr && !p.tags.some(t => tagMatches(t, state.selectedBaujahr))) return false;
    }
    if (state.hasTypStep && state.selectedTyp) {
      const hasTyp = p.tags?.some(t => t && String(t).toLowerCase().startsWith('size_'));
      if (hasTyp && !p.tags.some(t => tagMatches(t, state.selectedTyp))) return false;
    }
    return true;
  }

  function showResults() {
    let resultProducts = state.products.filter(productMatchesFilter);
    resultProducts = resultProducts.sort((a, b) => {
      const aHasTeller = (a.tags || []).some(t => String(t).toLowerCase() === 'teller');
      const bHasTeller = (b.tags || []).some(t => String(t).toLowerCase() === 'teller');
      if (aHasTeller && !bHasTeller) return -1;
      if (!aHasTeller && bHasTeller) return 1;
      return 0;
    });

    trackFunnel('results_view', { hasResults: resultProducts.length > 0, resultsCount: resultProducts.length });
    hideAllSteps();
    showStep(el.stepResults);

    const total = getTotalSteps();
    updateProgress(total, total);
    state.currentStep = total;

    const resultsNewsletter = document.getElementById('rq-results-newsletter');
    if (resultProducts.length === 0) {
      if (el.resultsGrid) el.resultsGrid.innerHTML = '';
      if (el.noResults) el.noResults.classList.remove('rq-hidden');
      if (resultsNewsletter) resultsNewsletter.classList.add('rq-hidden');
    } else {
      if (el.noResults) el.noResults.classList.add('rq-hidden');
      if (resultsNewsletter) resultsNewsletter.classList.remove('rq-hidden');
      const actionsWrap = document.getElementById('rq-results-newsletter-actions');
      const successWrap = document.getElementById('rq-results-newsletter-success');
      if (actionsWrap) actionsWrap.classList.remove('rq-hidden');
      if (successWrap) successWrap.classList.add('rq-hidden');
      renderProductCards(resultProducts);
    }
  }

  function renderProductCards(products) {
    if (!el.resultsGrid) return;
    const price = p => {
      const min = p.priceRange?.minVariantPrice;
      return min ? formatPrice(min.amount, min.currencyCode) : '';
    };
    const btnIcon = '<svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="m16 10a4 4 0 0 1-8 0"/></svg>';
    const fragment = document.createDocumentFragment();
    for (const p of products) {
      const btnText = esc(p.availableForSale ? (STRINGS.btnAddToCart || 'In den Warenkorb') : 'Ausverkauft');
      const card = document.createElement('div');
      card.className = 'product-card';
      card.dataset.productId = p.id;
      const productUrl = '/products/' + (p.handle || '');
      const imgHtml = p.featuredImage?.url
        ? `<img src="${esc(p.featuredImage.url)}" alt="${esc(p.featuredImage.altText || p.title)}" class="product-card__image" loading="lazy" decoding="async">`
        : '<div class="product-card__placeholder"><svg width="100" height="100" viewBox="0 0 100 100" fill="none"><rect width="100" height="100" fill="#f0f0f0"/><path d="M35 40L50 25L65 40L80 25V75H20V25L35 40Z" fill="#d0d0d0"/></svg></div>';
      const spinnerHtml = p.availableForSale
        ? '<div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>'
        : '';
      card.innerHTML = `
        <div class="product-card__image-container">
          <a href="${productUrl}" class="product-card__link" target="_blank" rel="noopener noreferrer">${imgHtml}</a>
          <div class="product-card__form product-card__form--absolute">
            <button type="button" class="product-card__cart-btn btn-custom rq-add-to-cart" data-variant-id="${esc(p.variantId || '')}" ${p.availableForSale ? '' : 'disabled'}>
              <span class="btn-custom-text">${btnText}</span>
              ${spinnerHtml}
              ${btnIcon}
            </button>
          </div>
        </div>
        <div class="product-card__content">
          <h3 class="product-card__title">
            <a href="${productUrl}" target="_blank" rel="noopener noreferrer">${esc(p.title)}</a>
          </h3>
          <div class="product-card__footer">
            <div class="product-card__price">
              <span class="product-card__price-current">${price(p)}</span>
            </div>
          </div>
        </div>
      `;
      const addBtn = card.querySelector('.rq-add-to-cart');
      if (addBtn && p.variantId) {
        addBtn.addEventListener('click', () => addToCart(p.variantId, addBtn));
      }
      const link = card.querySelector('.product-card__link');
      if (link) {
        link.addEventListener('click', () => {
          trackQuiz('click_button', {
            button_type: 'product_link',
            button_text: link.textContent?.trim() || null,
            product_handle: p.handle || null,
            product_id: p.id || null
          });
        });
      }
      fragment.appendChild(card);
    }
    el.resultsGrid.innerHTML = '';
    el.resultsGrid.appendChild(fragment);
  }

  function setButtonText(btn, text) {
    const span = btn?.querySelector('.btn-custom-text');
    if (span) span.textContent = text;
    else if (btn) btn.textContent = text;
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    trackQuiz('click_button', {
      button_type: 'add_to_cart',
      button_id: btn?.id || null,
      button_text: btn?.textContent?.trim() || null,
      variant_id: gidToVariantId(variantId)
    });
    var numericId = gidToVariantId(variantId);
    if (!/^\d+$/.test(String(numericId))) numericId = variantId;
    var spinner = btn.querySelector('.loading__spinner');
    btn.disabled = true;
    if (spinner) spinner.classList.remove('hidden');
    var formData = new FormData();
    formData.append('id', numericId);
    formData.append('quantity', '1');
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (data.status) {
          throw new Error(data.description || data.message || 'Fehler beim Hinzufügen.');
        }
        setButtonText(btn, STRINGS.btnInCart || 'Im Warenkorb');
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          var cartUrl = (typeof window !== 'undefined' && window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
          return fetch(cartUrl + '?section_id=cart-drawer')
            .then(function(res) { return res.text(); })
            .then(function(html) {
              var parser = new DOMParser();
              var newDoc = parser.parseFromString(html, 'text/html');
              var newCartDrawer = newDoc.querySelector('#CartDrawer');
              var currentCartDrawer = document.querySelector('#CartDrawer');
              if (newCartDrawer && currentCartDrawer) {
                currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
              }
              var newCartBubble = newDoc.querySelector('#cart-icon-bubble');
              var currentCartBubble = document.querySelector('#cart-icon-bubble');
              if (newCartBubble && currentCartBubble) {
                currentCartBubble.innerHTML = newCartBubble.innerHTML;
              }
              cartDrawer.classList.remove('is-empty');
              var cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
              if (cartDrawerItems) {
                cartDrawerItems.classList.remove('is-empty');
              }
              cartDrawer.open();
            });
        }
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
        setButtonText(btn, STRINGS.btnAddToCart || 'In den Warenkorb');
        if (error && error.message) alert(error.message);
      })
      .finally(function() {
        btn.disabled = false;
        if (spinner) spinner.classList.add('hidden');
      });
  }

  function isStepVisible(stepEl) {
    return stepEl && !stepEl.classList.contains('rq-hidden');
  }

  function goBack(e) {
    const buttonId = e && e.currentTarget ? e.currentTarget.id : null;
    const total = getTotalSteps();
    if (isStepVisible(el.stepResults)) {
      trackQuiz('click_back', {
        button_id: buttonId,
        back_from_step: 'results',
        back_to_step: (state.hasTypStep ? 'typ' : (state.hasBaujahrStep ? 'baujahr' : 'model'))
      });
      if (state.hasTypStep) {
        state.selectedTyp = null;
        const typTags = state.hasBaujahrStep
          ? getTypTagsFromProducts(getFilteredBaujahrProducts())
          : getTypTagsFromProducts(getFilteredModelProducts());
        renderTypStep(typTags);
        hideAllSteps();
        showStep(el.stepTyp);
        updateProgress(state.hasBaujahrStep ? 4 : 3, total);
        state.currentStep = state.hasBaujahrStep ? 4 : 3;
      } else if (state.hasBaujahrStep) {
        state.selectedBaujahr = null;
        let baujahrTags = getBaujahrTagsFromProducts(getFilteredModelProducts());
        baujahrTags = filterBlacklistedBaujahr(baujahrTags, state.selectedModel);
        renderBaujahrStep(baujahrTags);
        hideAllSteps();
        showStep(el.stepBaujahr);
        updateProgress(state.selectedModel ? 3 : 2, total);
        state.currentStep = state.selectedModel ? 3 : 2;
      } else {
        state.selectedModel = null;
        renderModelStep(filterBlacklistedModels(getModelTagsFromProducts(getProductsByBrand(state.selectedBrand)), state.selectedBrandLabel));
        hideAllSteps();
        showStep(el.stepModel);
        updateProgress(2, total);
        state.currentStep = 2;
      }
    } else if (isStepVisible(el.stepTyp)) {
      trackQuiz('click_back', {
        button_id: buttonId,
        back_from_step: 'typ',
        back_to_step: (state.hasBaujahrStep ? 'baujahr' : 'model')
      });
      state.selectedTyp = null;
      if (state.hasBaujahrStep) {
        let baujahrTags = getBaujahrTagsFromProducts(getFilteredModelProducts());
        baujahrTags = filterBlacklistedBaujahr(baujahrTags, state.selectedModel);
        renderBaujahrStep(baujahrTags);
        hideAllSteps();
        showStep(el.stepBaujahr);
        updateProgress(state.selectedModel ? 3 : 2, total);
        state.currentStep = state.selectedModel ? 3 : 2;
      } else {
        state.selectedModel = null;
        renderModelStep(filterBlacklistedModels(getModelTagsFromProducts(getProductsByBrand(state.selectedBrand)), state.selectedBrandLabel));
        hideAllSteps();
        showStep(el.stepModel);
        updateProgress(2, total);
        state.currentStep = 2;
      }
    } else if (isStepVisible(el.stepBaujahr)) {
      trackQuiz('click_back', {
        button_id: buttonId,
        back_from_step: 'baujahr',
        back_to_step: (function() {
          const brandProducts = getProductsByBrand(state.selectedBrand);
          const modelTags = filterBlacklistedModels(getModelTagsFromProducts(brandProducts), state.selectedBrandLabel);
          let baujahrTags = getBaujahrTagsFromProducts(brandProducts);
          baujahrTags = filterBlacklistedBaujahr(baujahrTags, state.selectedModel);
          return (modelTags.length === 0 && !isWorxBrandSelected() && baujahrTags.length > 0) ? 'brand' : 'model';
        })()
      });
      state.selectedBaujahr = null;
      const brandProducts = getProductsByBrand(state.selectedBrand);
      const modelTags = filterBlacklistedModels(getModelTagsFromProducts(brandProducts), state.selectedBrandLabel);
      let baujahrTags = getBaujahrTagsFromProducts(brandProducts);
      baujahrTags = filterBlacklistedBaujahr(baujahrTags, state.selectedModel);
      if (modelTags.length === 0 && !isWorxBrandSelected() && baujahrTags.length > 0) {
        state.selectedModel = null;
        renderBrandStep();
        hideAllSteps();
        showStep(el.stepBrand);
        updateProgress(1, total);
        state.currentStep = 1;
      } else {
        state.selectedModel = null;
        renderModelStep(modelTags);
        hideAllSteps();
        showStep(el.stepModel);
        updateProgress(2, total);
        state.currentStep = 2;
      }
    } else if (isStepVisible(el.stepModel)) {
      trackQuiz('click_back', { button_id: buttonId, back_from_step: 'model', back_to_step: 'brand' });
      state.selectedBrand = null;
      state.selectedBrandLabel = null;
      state.selectedModel = null;
      state.selectedBaujahr = null;
      state.selectedTyp = null;
      renderBrandStep();
      hideAllSteps();
      showStep(el.stepBrand);
      updateProgress(1, total);
      state.currentStep = 1;
    } else if (isStepVisible(el.stepOtherBrand)) {
      trackQuiz('click_back', { button_id: buttonId, back_from_step: 'other_brand', back_to_step: 'brand' });
      hideAllSteps();
      showStep(el.stepBrand);
      updateProgress(1, total);
      state.currentStep = 1;
    } else if (isStepVisible(el.stepOtherModel)) {
      trackQuiz('click_back', { button_id: buttonId, back_from_step: 'other_model', back_to_step: 'model' });
      renderModelStep(filterBlacklistedModels(
        getModelTagsFromProducts(getProductsByBrand(state.selectedBrand)),
        state.selectedBrandLabel
      ));
      hideAllSteps();
      showStep(el.stepModel);
      updateProgress(2, total);
      state.currentStep = 2;
    } else if (isStepVisible(el.stepBrand)) {
      return;
    }
  }

  function renderMesserProductCard(container, product) {
    if (!container || !product) return;
    const price = p => {
      const min = p.priceRange?.minVariantPrice;
      return min ? formatPrice(min.amount, min.currencyCode) : '';
    };
    const btnIcon = '<svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="m16 10a4 4 0 0 1-8 0"/></svg>';
    const btnText = esc(product.availableForSale ? (STRINGS.btnAddToCart || 'In den Warenkorb') : 'Ausverkauft');
    const productUrl = '/products/' + (product.handle || '');
    const imgHtml = product.featuredImage?.url
      ? `<img src="${esc(product.featuredImage.url)}" alt="${esc(product.featuredImage.altText || product.title)}" class="product-card__image" loading="lazy" decoding="async">`
      : '<div class="product-card__placeholder"><svg width="100" height="100" viewBox="0 0 100 100" fill="none"><rect width="100" height="100" fill="#f0f0f0"/><path d="M35 40L50 25L65 40L80 25V75H20V25L35 40Z" fill="#d0d0d0"/></svg></div>';
    const spinnerHtml = product.availableForSale
      ? '<div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>'
      : '';
    const brandLabel = (state.selectedBrandLabel || state.selectedBrand || '').replace(/^brand_/i, '').replace(/_/g, ' ') || 'Modelle';
    container.innerHTML = `
      <h3 class="rq-messer-label">Passend für alle ${esc(brandLabel)} Modelle:</h3>
      <div class="product-card rq-messer-card">
        <div class="product-card__image-container">
          <a href="${productUrl}" class="product-card__link" target="_blank" rel="noopener noreferrer">${imgHtml}</a>
          <div class="product-card__form product-card__form--absolute">
            <button type="button" class="product-card__cart-btn btn-custom rq-add-to-cart" data-variant-id="${esc(product.variantId || '')}" ${product.availableForSale ? '' : 'disabled'}>
              <span class="btn-custom-text">${btnText}</span>
              ${spinnerHtml}
              ${btnIcon}
            </button>
          </div>
        </div>
        <div class="product-card__content">
          <h3 class="product-card__title">
            <a href="${productUrl}" target="_blank" rel="noopener noreferrer">${esc(product.title)}</a>
          </h3>
          <div class="product-card__footer">
            <div class="product-card__price">
              <span class="product-card__price-current">${price(product)}</span>
            </div>
          </div>
        </div>
      </div>
    `;
    const addBtn = container.querySelector('.rq-add-to-cart');
    if (addBtn && product.variantId) {
      addBtn.addEventListener('click', () => addToCart(product.variantId, addBtn));
    }
  }

  function showOtherForm(type, presetValue) {
    const total = getTotalSteps();
    hideAllSteps();
    if (type === 'brand') {
      showStep(el.stepOtherBrand);
      updateProgress(1, total);
      state.currentStep = 1;
    } else {
      showStep(el.stepOtherModel);
      updateProgress(2, total);
      state.currentStep = 2;
      if (presetValue) {
        const input = $('rq-other-model-input');
        if (input) input.value = String(presetValue);
      }
      const messerContainer = $('rq-other-model-messer');
      if (messerContainer && state.selectedBrand) {
        const messerProducts = getMesserProductsForBrand(state.selectedBrand);
        messerContainer.innerHTML = '';
        if (messerProducts.length > 0) {
          renderMesserProductCard(messerContainer, messerProducts[0]);
        }
      }
    }
  }

  function resetOtherForms() {
    const formInnerBrand = $('rq-other-brand-form-inner');
    const successBrand = $('rq-other-brand-success');
    const formInnerModel = $('rq-other-model-form-inner');
    const successModel = $('rq-other-model-newsletter-success');
    if (formInnerBrand) formInnerBrand.classList.remove('rq-hidden');
    if (successBrand) successBrand.classList.add('rq-hidden');
    if (formInnerModel) formInnerModel.classList.remove('rq-hidden');
    if (successModel) successModel.classList.add('rq-hidden');
  }

  function populateOtherFormBody(type, form) {
    const bodyEl = $(type === 'brand' ? 'rq-other-brand-body' : 'rq-other-model-body');
    const inputEl = $(type === 'brand' ? 'rq-other-brand-input' : 'rq-other-model-input');
    const emailEl = form.querySelector('input[name="contact[email]"]');
    const label = type === 'brand' ? 'Marke' : 'Modell';
    const value = (inputEl?.value || '').trim();
    const email = (emailEl?.value || '').trim();
    const supportEmail = CONFIG.supportEmail || 'customersupport@beos-tools.com';
    const bodyLines = [
      'Quiz-Anfrage: ' + label + ' nicht gefunden',
      'Eingabe: ' + value,
      'E-Mail Kunde: ' + email,
      'Support-E-Mail: ' + supportEmail
    ];
    if (type === 'model' && state.selectedBrand) {
      bodyLines.splice(2, 0, 'Marke: ' + (state.selectedBrandLabel || state.selectedBrand));
    }
    const bodyText = bodyLines.join('\n');
    if (bodyEl) bodyEl.value = bodyText;
    return { bodyText, email };
  }

  function submitOtherForm(type, form) {
    populateOtherFormBody(type, form);
    const bodyEl = $(type === 'brand' ? 'rq-other-brand-body' : 'rq-other-model-body');
    const bodyText = bodyEl?.value || '';
    const emailEl = form.querySelector('input[name="contact[email]"]');
    const email = (emailEl?.value || '').trim();

    const formInner = $(type === 'brand' ? 'rq-other-brand-form-inner' : 'rq-other-model-form-inner');
    const successEl = $(type === 'brand' ? 'rq-other-brand-success' : 'rq-other-model-success');
    const submitBtn = form.querySelector('button[type="submit"]');
    const contactIframe = document.getElementById('rq-contact-iframe');

    form.setAttribute('target', 'rq-contact-iframe');
    if (contactIframe) {
      contactIframe.onload = function() {
        contactIframe.onload = null;
        form.removeAttribute('target');
        if (formInner) formInner.classList.add('rq-hidden');
        if (successEl) successEl.classList.remove('rq-hidden');
        if (submitBtn) submitBtn.disabled = false;
      };
    }

    function doSubmit() {
      if (submitBtn) submitBtn.disabled = true;
      form.submit();
    }

    if (typeof window.Shopify !== 'undefined' && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      window.Shopify.captcha.protect(form, doSubmit);
    } else {
      doSubmit();
    }
  }

  function bindEvents() {
    const quizStartTs = Date.now();
    function fireDropoff(dropoff_reason) {
      trackQuiz('dropoff', {
        dropoff_reason,
        last_quiz_step: getVisibleStepName(),
        time_on_quiz_ms: Date.now() - quizStartTs
      });
    }
    window.addEventListener('pagehide', () => fireDropoff('pagehide'));
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') fireDropoff('visibility_hidden');
    });

    ['rq-back-model','rq-back-baujahr','rq-back-typ','rq-back-results','rq-back-other-brand','rq-back-other-model'].forEach(id => { const b = $(id); if (b) b.addEventListener('click', goBack); });

    const brandWrap = $('rq-options-brand-wrap');
    const modelWrap = $('rq-options-model-wrap');
    if (brandWrap) {
      brandWrap.addEventListener('click', function(e) {
        const pill = e.target.closest('.brand-filter__pill');
        if (pill && pill.dataset.brand) {
          selectBrand({ label: pill.dataset.brandLabel || pill.dataset.brand, tag: pill.dataset.brand });
        } else if (e.target.dataset.other === 'brand' || e.target.closest('[data-other="brand"]')) {
          trackQuiz('click_button', { button_type: 'other', button_text: 'Andere Marke', button_id: 'rq-other-brand' });
          showOtherForm('brand');
        }
      });
    }
    if (modelWrap) {
      modelWrap.addEventListener('click', function(e) {
        if (e.target.dataset.other === 'model') {
          trackQuiz('click_button', { button_type: 'other', button_text: 'Anderes Modell', button_id: 'rq-other-model' });
          showOtherForm('model');
        }
      });
    }

    const brandForm = document.getElementById('rq-other-brand-form-form');
    function handleOtherFormSubmit(type, form, e) {
      populateOtherFormBody(type, form);
      if (CONFIG.contactSubmitNative) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      submitOtherForm(type, form);
    }
    if (brandForm) {
      brandForm.addEventListener('submit', function(e) {
        handleOtherFormSubmit('brand', this, e);
      }, true);
    }
    const otherModelNewsletterForm = document.getElementById('rq-other-model-newsletter-form');
    if (otherModelNewsletterForm) {
      otherModelNewsletterForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const form = e.target;
        const emailInput = form.querySelector('input[type="email"]');
        const email = emailInput?.value?.trim();
        if (!email) return;
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        try {
          const formData = new FormData(form);
          const actionUrl = (form.getAttribute('action') || form.action || '').split('#')[0];
          const res = await fetch(actionUrl, { method: 'POST', body: formData });
          if (res.ok) {
            trackFunnel('newsletter_submitted');
            const formInner = document.getElementById('rq-other-model-form-inner');
            const successEl = document.getElementById('rq-other-model-newsletter-success');
            if (formInner) formInner.classList.add('rq-hidden');
            if (successEl) successEl.classList.remove('rq-hidden');
          }
        } finally {
          if (submitBtn) submitBtn.disabled = false;
        }
      });
    }

    const resultsNewsletterForm = document.getElementById('rq-results-newsletter-form');
    if (resultsNewsletterForm) {
      resultsNewsletterForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const form = e.target;
        const emailInput = form.querySelector('input[type="email"]');
        const email = emailInput?.value?.trim();
        if (!email) return;
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        try {
          const formData = new FormData(form);
          const actionUrl = (form.getAttribute('action') || form.action || '').split('#')[0];
          const res = await fetch(actionUrl, { method: 'POST', body: formData });
          if (res.ok) {
            trackFunnel('newsletter_submitted');
            const actionsWrap = document.getElementById('rq-results-newsletter-actions');
            const successWrap = document.getElementById('rq-results-newsletter-success');
            if (actionsWrap) actionsWrap.classList.add('rq-hidden');
            if (successWrap) successWrap.classList.remove('rq-hidden');
          }
        } finally {
          if (submitBtn) submitBtn.disabled = false;
        }
      });
    }

    el.newsletterForm = document.getElementById('rq-newsletter-form');
    el.newsletterSuccess = document.getElementById('rq-newsletter-success');
    if (el.newsletterForm) {
      el.newsletterForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const form = e.target;
        const emailInput = form.querySelector('input[type="email"]');
        const email = emailInput?.value?.trim();
        if (!email) return;
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        try {
          const formData = new FormData(form);
          const actionUrl = (form.getAttribute('action') || form.action || '').split('#')[0];
          const res = await fetch(actionUrl, {
            method: 'POST',
            body: formData
          });
          if (res.ok) {
            form.classList.add('rq-hidden');
            if (el.newsletterSuccess) el.newsletterSuccess.classList.remove('rq-hidden');
          } else {
            if (submitBtn) submitBtn.disabled = false;
          }
        } catch (_) {
          if (submitBtn) submitBtn.disabled = false;
        }
      });
    }
  }

  function cacheElements() {
    el.root = $('roboparts-quiz-root');
    el.loading = $('rq-loading');
    el.error = $('rq-error');
    el.quiz = $('rq-quiz');
    el.progressFill = $('rq-progress-fill');
    el.progressBar = el.root?.querySelector('.rq-progress-bar') || document.querySelector('.rq-progress-bar');
    el.progressLabel = $('rq-progress-label');
    el.stepBrand = $('rq-step-brand');
    el.stepModel = $('rq-step-model');
    el.stepOtherBrand = $('rq-step-other-brand');
    el.stepOtherModel = $('rq-step-other-model');
    el.stepBaujahr = $('rq-step-baujahr');
    el.stepTyp = $('rq-step-typ');
    el.stepResults = $('rq-step-results');
    el.optionsBrand = $('rq-options-brand');
    el.optionsModel = $('rq-options-model');
    el.optionsBaujahr = $('rq-options-baujahr');
    el.optionsTyp = $('rq-options-typ');
    el.resultsGrid = $('rq-results-grid');
    el.noResults = $('rq-no-results');
  }

  async function init() {
    cacheElements();
    bindEvents();

    if (!CONFIG.storefrontAccessToken || CONFIG.storefrontAccessToken === 'SET_YOUR_STOREFRONT_ACCESS_TOKEN') {
      trackFunnel('quiz_error', { reason: 'no_token' });
      showState('error');
      if (el.error) {
        const text = el.error.querySelector('.rq-error-text');
        if (text) text.textContent = 'Storefront Access Token nicht konfiguriert. Bitte in den Section-Einstellungen (Roboparts Quiz) eintragen.';
      }
      return;
    }

    try {
      state.products = await fetchAllProducts();
      showState('quiz');
      trackFunnel('brand_view');
      updateProgress(1, 3);
      renderBrandStep();
      if (CONFIG.contactSubmitNative && typeof window.location !== 'undefined' && window.location.search.indexOf('contact_posted=true') !== -1) {
        var formInner = $('rq-other-brand-form-inner');
        var successEl = $('rq-other-brand-success');
        if (formInner && successEl) {
          hideAllSteps();
          showStep(el.stepOtherBrand);
          formInner.classList.add('rq-hidden');
          successEl.classList.remove('rq-hidden');
        }
        try { window.history.replaceState({}, '', window.location.pathname); } catch (_) {}
      }
    } catch (err) {
      trackFunnel('quiz_error', { reason: 'fetch_failed' });
      showState('error');
      const errEl = el.error?.querySelector('.rq-error-text');
      if (errEl) {
        const msg = err && err.message ? err.message : String(err);
        errEl.textContent = msg.includes('Failed to fetch') || msg.includes('NetworkError')
          ? 'Netzwerkfehler. Prüfe die Verbindung und lade die Seite neu.'
          : 'Fehler: ' + msg;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
